"use client";

import { IconCheck, IconAlertCircle } from "@/lib/tabler-icons";
import { cn } from "@/lib/utils";

interface FormStatusMessageProps {
	type: "success" | "error" | "info";
	message: string;
	className?: string;
}

export const FormStatusMessage = ({
	type,
	message,
	className,
}: FormStatusMessageProps) => {
	const getStyles = () => {
		switch (type) {
			case "success":
				return "text-ink border-border bg-cream";
			case "error":
				return "text-terracotta border-terracotta/30 bg-terracotta/5";
			case "info":
				return "text-ink border-border bg-cream";
			default:
				return "text-muted-foreground border-border bg-cream";
		}
	};

	const getIcon = () => {
		switch (type) {
			case "success":
				return <IconCheck className="w-4 h-4 text-terracotta" />;
			case "error":
				return <IconAlertCircle className="w-4 h-4 text-terracotta" />;
			case "info":
				return <IconCheck className="w-4 h-4 text-terracotta" />;
			default:
				return <IconCheck className="w-4 h-4 text-terracotta" />;
		}
	};

	return (
		<div
			className={cn(
				"font-body inline-flex items-center gap-2 px-4 py-2 rounded-lg border text-sm",
				getStyles(),
				className
			)}
			role="alert"
		>
			{getIcon()}
			{message}
		</div>
	);
};
